import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
// import ProductList from '../mobile/pages/ProductList'
// import ProductSwiper2 from 'src/mobile/components/Homepage/ProductSroll'
import ProductSwiper1 from 'src/mobile/components/Homepage/ProductSrollHomepage'
import { SITE_MATE_DATA } from 'src/utils/constant'
import { ReactComponent as HelpIcon } from 'src/mobile/assets/icons/help.svg'
import { ReactComponent as VectorIcon } from 'src/mobile/assets/icons/Home_Vector.svg'
import { ReactComponent as ViewAllIcon } from 'src/mobile/assets/icons/Home_all.svg'
import Typography from '@material-ui/core/Typography'
import { makeStyles, createStyles, fade } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { useRouteMatch, useParams, useHistory } from 'react-router-dom'
import { getTestCenterList, getTestCenterInfo } from '../store/slices/testCenterSlice'
import { useTranslation } from 'react-i18next'
import { useImageTranslation } from 'src/hooks'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core'
import 'swiper/swiper-bundle.min.css'
import 'swiper/components/pagination/pagination.min.css'
import 'swiper/components/navigation/navigation.min.css'
// import classnames from 'classnames'
import { buttonClick } from 'src/utils/trackingCode'
import { Helmet  } from 'react-helmet'

SwiperCore.use([Autoplay, Pagination, Navigation])

const useStyles = makeStyles((theme) =>
  createStyles({
    homepageBanner: {
      display: 'block',
      width: 742,
      maxWidth: '100%',
      // maxHeight: `calc(100vh - ${theme.spacing(26)}px)`,
      margin: '0 auto',
      cursor: 'pointer',
      borderRadius: 24,
      marginBottom: 12,
    },

    item: {
      cursor: 'pointer',
      padding: theme.spacing(4, 0),
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
    },

    swiperWrapper: {
      marginTop: theme.spacing(-6),
      '& .swiper-button-prev,.swiper-button-next': {
        '&:after': {
          fontSize: theme.spacing(5),
          color: fade(theme.palette.common.black, 0.25),
          [theme.breakpoints.down('xs')]: {
            fontSize: theme.spacing(3),
          },
        },
      },
      '& .swiper-button-prev': {
        left: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
          left: theme.spacing(0.8),
        },
      },
      '& .swiper-button-next': {
        right: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
          right: theme.spacing(0.8),
        },
      },
      WebkitBackfaceVisibility: 'hidden',
      '& .swiper-slide': {
        width: '100%',
        WebkitBackfaceVisibility: 'hidden',
      },
      '& .swiper-pagination-bullet': {
        opacity: 0.9,
      },
      '& .swiper-pagination-bullet-active': {
        opacity: 1,
        background: fade(theme.palette.common.white, 0.9),
      },
      '& .swiper-pagination': {
        [theme.breakpoints.down('xs')]: {
          bottom: 'auto',
          top: `calc( 100% - ${theme.spacing(2.5)}px)`,
        },
      },
    },
    product: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: theme.spacing(50.75),
      // height: theme.spacing(94),
      border: ' 1px solid #D9D9D9',
      borderRadius: theme.spacing(3),
      textAlign: 'left',
      cursor: 'pointer',
    },
    homepageBannerText: {
      fontSize: 20,
      fontWeight: 600,
      marginTop: theme.spacing(1),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      lineClamp: 2,
      WebkitBoxOrient: 'vertical',
    },
    homepagetext: {
      color: theme.palette.secondary.main,
      fontSize: 14,
    },
    homeBottomContainer: {
      paddingTop: theme.spacing(16),
      paddingBottom: theme.spacing(16),
      backgroundColor: theme.palette.background.container,
    },
    homeBottomBox: {
      backgroundColor: 'white',
      margin: '0 auto',
      width: theme.spacing(106.5),
      height: theme.spacing(56),
      display: 'flex',
      padding: theme.spacing(8),
      borderRadius: theme.spacing(3),
    },
    homeBottomImg: {
      width: theme.spacing(40),
      height: theme.spacing(40),
    },
    viewAllbtn: {
      width: theme.spacing(23),
      height: theme.spacing(7),
      background: theme.palette.secondary.main,
      borderRadius: theme.spacing(1),
      padding: '16px 24px',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto',
      color: 'white',
      fontSize: theme.spacing(2),
      fontWeight: 600,
      marginBottom: theme.spacing(13),
      // marginTop: theme.spacing(7),
      display: 'flex',
      lineHeight: '150%',
      cursor: 'pointer',
    },
    hoverPointer: {
      cursor: 'pointer',
    },
    viewAllbtnIcon: {
      display: 'flex',
      alignSelf: 'center',
      marginLeft: theme.spacing(1),
    },
    homeBottomTwoBox: {
      cursor: 'pointer',
      marginTop: theme.spacing(3),
      height: theme.spacing(7),
      border: '1px solid #E5E7EB',
      borderRadius: theme.spacing(1),
      textAlign: 'center',
      padding: theme.spacing(2),
      fontWeight: 600,
      fontSize: 16,
      width: theme.spacing(37.5),
      lineHeight: '150%',
      display: 'flex',
      justifyContent: 'center',
    },
    homeBottomTwoIcon: {
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(0.4),
    },
  }),
)

const HomePage = () => {
  const match = useRouteMatch('/clinic/:id')
  const classes = useStyles()
  const { id } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const [tImage] = useImageTranslation()
  const { userInfo } = useSelector((state) => state.auth)
  const { testCenterList } = useSelector((state) => state.testCenter)
  useEffect(() => {
    if (!match && !testCenterList?.length) {
      dispatch(getTestCenterList({ clinicType: 1 }))
    }
  }, [])
  useEffect(() => {
    if (match) {
      dispatch(getTestCenterInfo({ id: Number(id) }))
    }
  }, [id])
  const HomeBottomtext = [
    {
      label: t('footer.whatsapp'),
      icon: VectorIcon,
      toWhatsApp: true,
      number:
        i18n.language === 'zh-HK'
          ? SITE_MATE_DATA.WHATSAPP_HELP_HK
          : i18n.language === 'en'
          ? SITE_MATE_DATA.WHATSAPP_HELP_EN
          : SITE_MATE_DATA.WHATSAPP_HELP_CN,
    },
    {
      label: t('glossary.faq'),
      icon: HelpIcon,
      path: '/faq',
    },
  ]
  const bannerList = [
    // {
    //   path: '',
    //   bannerSrc: tImage('Chris', 'webp'),
    //   id: 'EH_Hero_Banner_Xmas22Promo_Book_Button',
    //   auth: false,
    // },
    // {
    //   path: '/doctor',
    //   bannerSrc: tImage('cancer_banner', 'webp'),
    //   id: 'EH_Hero_Banner_CancerScreen_Book_Button',
    //   auth: false,
    // },
    {
      // path: `/agreement/${
      //   process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 16 : 8
      // }`,
      path: `/promotions_NEW330`,
      bannerSrc: tImage('program_banner', 'webp'),
      id: 'EH_Hero_Banner_Healthcheck_KnowMore',
      text: t('HomePage.EH_Hero_Banner_Healthcheck_KnowMore'),
      buttonName: 'EH_HP_HeroBanner1',
      buttonId: 'EH_HP_HeroBanner1',
    },
    // {
    //   path: `/agreement/${
    //     process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 14 : 7
    //   }`,
    //   bannerSrc: tImage('atome_banner', 'webp'),
    //   id: 'EH_Hero_Banner_Atome_KnowMore',
    //   text:t('HomePage.EH_Hero_Banner_Atome_KnowMore'),
    //   auth: false,
    // },
  ]

  return (
    <Box position="static" color="primary">
      <Helmet>
        <meta name="description" content={t('seoDescription.homepage')} />
        <title>{t('seoTitle.homepage')}</title>
      </Helmet>
      <Box pd={0}>
        <Box
          // height={`${(2617 / 5000) * 100}vw`}
          // maxHeight="calc(100vh - 208px)"
          mb={5}
        >
          <Swiper
          // navigation
          // slidesPerView={2}
          // spaceBetween={40}
          // centeredSlides={true}
          // autoplay={{
          //   delay: 5000,
          //   disableOnInteraction: false,
          // }}
          // className={classes.swiperWrapper}
          // speed={900}
          // loop
          // watchOverflow={true}
          // watchSlidesVisibility={true}
          // initialSlide={0}
          >
            {bannerList?.map((item, index) => (
              <Box key={index}>
                <SwiperSlide>
                  <Box
                    mt={2}
                    onClick={() => {
                      buttonClick(item.buttonName, item.buttonId)
                      history.push(!userInfo && item.auth ? '/signin' : item.path)
                    }}
                  >
                    <img
                      className={classes.homepageBanner}
                      src={item.bannerSrc}
                      id={item.id}
                      alt="homepage banner"
                    />
                    <Box fontWeight={600} width={742} margin="0 auto">
                      <Box className={classes.homepagetext}>{t('HomePage.latest_offers')}</Box>
                      <Box className={classes.homepageBannerText}>{item.text}</Box>
                    </Box>
                  </Box>
                </SwiperSlide>
              </Box>
            ))}
          </Swiper>
        </Box>
        <Box>
          <Typography component="div">
            <Box pb={2} fontSize={26} textAlign="center" fontWeight="700" color="primary.main">
              {t('HomePage.hot_Production')}
            </Box>
          </Typography>
          <Box pb={1} pl={8} width="100%">
            {/* <ProductList /> */}
            <ProductSwiper1 />
            {/* <ProductSwiper2 /> */}
          </Box>
        </Box>
        <Box
          className={classes.viewAllbtn}
          onClick={() => {
            buttonClick('EH_HP_Product_SeeAll', 'EH_HP_Product_SeeAll')
            history.push('/ProductList')
          }}
        >
          <Box>{t('common.check_all')}</Box>
          <ViewAllIcon className={classes.viewAllbtnIcon} />
        </Box>

        <Box className={classes.homeBottomContainer}>
          <Box className={classes.homeBottomBox}>
            <img
              className={classes.homeBottomImg}
              src={tImage('home_bottom_img_PC', 'webp')}
              alt="product info banner"
            />
            <Box pl={5} ml={3}>
              <Box mt={3} textAlign="center">
                <Box fontSize={32} fontWeight={600} lineHeight="150%">
                  {t('HomePage.get_support')}
                </Box>
                <Box width="246px" ml={3.3} mt={2} fontSize={16} fontWeight={400} color="#4B5563">
                  {t('HomePage.contact_us')}
                </Box>
              </Box>
              <Box>
                {HomeBottomtext?.map((item, index) => (
                  <Box
                    className={classes.homeBottomTwoBox}
                    key={index}
                    onClick={() => {
                      item.toWhatsApp
                        ? buttonClick('EH_HP_WhatsApp', 'EH_HP_WhatsApp')
                        : buttonClick('EH_HP_FAQ', 'EH_HP_FAQ')
                      item.toWhatsApp ? (window.location.href = item.number) : history.push(item.path)
                    }}
                  >
                    <item.icon className={classes.homeBottomTwoIcon} />
                    <Box>{item.label}</Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default HomePage
